export default "__VITE_ASSET__f7dfde9d__"